import React, { useEffect } from 'react'
import Footer from '../componets/General/Footer'
import NavBar from '../componets/General/NavBar'
import logo from './../assets/iconNav.png'
const NotFound = () =>{
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
    const styles = {
    
        height: "auto",
        height: "100%"
        }
        const styles2 = {
    
            textAlign: "center",
            width: "100%",
            marginTop: "180px",
            paddingBottom: "200px"
        }
    return(
        <div style = {styles}>
            <NavBar/>
            <div>
                <div style = {styles2}>
                    <img src = {logo} alt = "..."/>
                    <h1>Error 404</h1>
                    <h2>Página no encontrada</h2>
                    
                </div>
            </div>
            <Footer/>
        </div>
    )
}
export default NotFound